import { render } from "./IssueResolution.vue?vue&type=template&id=733293d7"
import script from "./IssueResolution.vue?vue&type=script&lang=js"
export * from "./IssueResolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__